import { render, staticRenderFns } from "./MobileApprovalAwait.vue?vue&type=template&id=1a563dc8&scoped=true&"
import script from "./MobileApprovalAwait.vue?vue&type=script&lang=js&"
export * from "./MobileApprovalAwait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a563dc8",
  null
  
)

export default component.exports